(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["build-a-box"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    let header = document.querySelector('.shopify-section.section-header');
    let announcement = document.querySelector('#shopify-section-announcement-bar');
    function setHeaderHeight() {
      let headerHeight = header ? header.getBoundingClientRect().height : 0;
      let announcementHeight = 0;
      if (announcement && announcement.compareDocumentPosition(header) & Node.DOCUMENT_POSITION_FOLLOWING) {
        // Only add if announcement is above header in DOM
        announcementHeight = announcement.getBoundingClientRect().height;
      }
      document.documentElement.style.setProperty('--header-height', `${parseInt(headerHeight + announcementHeight)}px`);
    }
    setHeaderHeight();

    var headerObserver = new ResizeObserver(setHeaderHeight);
    if (header) {
      headerObserver.observe(header);
    }
    if (announcement) {
      var announcementObserver = new ResizeObserver(setHeaderHeight);
      announcementObserver.observe(announcement);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
